/**
 * Формирует фамилию и инициалы из ФИО
 * @param lastName фамилия
 * @param firstName имя
 * @param middleName отчество
 */
export function fullNameToShortName(
	lastName: string,
	firstName: string,
	middleName: string,
) {
	if (lastName === firstName) return lastName

	return `${lastName}${firstName ? ` ${firstName[0]}.` : ""}${middleName ? ` ${middleName[0]}.` : ""}`
}
